import React from "react";
import AdminLayout from "../AdminLayout";
import NewsletterSection from "./NewsletterSection";

const Newsletter = () => {
  return (
    <AdminLayout
      selectedMenuItem="Newsletter"
      pageTitle="Newsletter Audience"
      pageSubtitle="Manage subscribers in a cleaner editorial-style admin surface with better spacing and controls."
    >
      <NewsletterSection />
    </AdminLayout>
  );
};

export default Newsletter;
